import type { AdDataContextValue, RawMeta } from '../types';

interface RawMedia {
  uuid: string;
  contentType: string;
}

interface RawImage {
  uuid: string;
  type: string;
}

interface RawCountry {
  code: string | null;
}

interface RawAddress {
  street: string | null;
  additional: string | null;
  zip: string;
  city: string;
  country: RawCountry | null;
  latitude: string | null;
  longitude: string | null;
}

interface RawEmail {
  email: string;
}

interface RawPhone {
  phone: string;
}

interface RawContact {
  gender: Gender | null;
  firstName: string | null;
  lastName: string | null;
  /**
   * Get assigned Emails
   */
  emails: RawEmail[] | null;
  /**
   * Get assigned Phones
   */
  phones: RawPhone[] | null;
  image: RawImage | null;
}

interface RawBranchMeta extends RawMeta {
  custom: Record<string, string>;
  open: Record<string, string>;
}

export interface RawBranch {
  id: string;
  name: string;
  websiteUrl: string | null;
  privacyUrl: string | null;
  imprintUrl: string | null;
  phone: string | null;
  email: string | null;
  hasOpeningHours: boolean;
  /**
   * Get number of modified products
   */
  productCount: number | null;
  meta: RawBranchMeta | null;
  reference: string;
  logo: RawMedia | null;
  image: RawMedia | null;
  mapMarker: RawMedia | null;
  address: RawAddress | null;
  contacts: RawContact[] | null;
}

interface Media {
  uuid: string;
  contentType: string;
  url?: string;
}

interface Image {
  uuid: string;
  type: string;
  url?: string;
}

export interface Address {
  street?: string;
  additional?: string;
  zip?: string;
  city?: string;
  country?: {
    code: string;
  };
  latitude?: number;
  longitude?: number;
}

export enum Gender {
  DIVERS = 'divers',
  FEMALE = 'female',
  MALE = 'male',
}

interface Contact {
  gender: Gender;
  firstName: string;
  lastName: string;
  emails?: string[];
  phones?: string[];
  image?: Image;
}

export interface Branch {
  id: string;
  name: string;
  websiteUrl?: string;
  privacyUrl?: string;
  imprintUrl?: string;
  phone?: string;
  email?: string;
  hasOpeningHours: boolean;
  openingHours: {
    [day: string]: string;
  };
  productCount: number;
  reference: string;
  logo?: Media | null;
  image?: Media | null;
  mapMarker?: Media | null;
  address: Address;
  contacts: Contact[];
}

export type RawStoresConfig = RawBranch[];
export type StoresConfig = Branch[];

export type StoresContextValue = AdDataContextValue<StoresConfig>;
